import { render } from "./PavilionMapDraggable.vue?vue&type=template&id=05f2dde8&scoped=true"
import script from "./PavilionMapDraggable.vue?vue&type=script&lang=js"
export * from "./PavilionMapDraggable.vue?vue&type=script&lang=js"

import "./PavilionMapDraggable.vue?vue&type=style&index=0&id=05f2dde8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f2dde8"]])

export default __exports__